module.exports = __webpack_public_path__ + "static/img/BN@3x.73f921d3.jpg";